// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XuXFkJW8xO_NoW {
  box-sizing: border-box;
  padding: var(--ds-space-025, 2px);
}
.kaUDltleo64VCW {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: var(--ds-space-025, 2px);
  overflow: hidden;
  border-radius: var(--ds-border-radius-100, 4px);
}
.kaUDltleo64VCW .isZVqKA3jLl0YR {
  display: flex;
  visibility: hidden;
  flex: 0 0 auto;
  margin: var(--ds-space-050, 4px);
  gap: var(--ds-space-050, 4px);
}
.kaUDltleo64VCW .isZVqKA3jLl0YR button {
  padding: var(--ds-space-050, 4px);
}
.kaUDltleo64VCW:hover,
.kaUDltleo64VCW:focus-within {
  background: var(--ds-background-neutral-hovered, #091e4224);
}
.kaUDltleo64VCW:hover .isZVqKA3jLl0YR,
.kaUDltleo64VCW:focus-within .isZVqKA3jLl0YR {
  visibility: visible;
}
.kaUDltleo64VCW:focus-within,
.kaUDltleo64VCW.rsx2KAuQpRoK_L {
  outline: var(--ds-border-focused, #388bff) auto 2px;
  outline-offset: 2px;
}
.mac .kaUDltleo64VCW:focus-within,
.mac .kaUDltleo64VCW.rsx2KAuQpRoK_L {
  outline-color: -webkit-focus-ring-color;
}
.kaUDltleo64VCW:focus-within .mac.firefox,
.kaUDltleo64VCW.rsx2KAuQpRoK_L .mac.firefox {
  outline-color: AccentColor;
}
.itBVBT9AQ__EL2 {
  flex: 1 1;
  justify-content: flex-start;
  min-width: 0;
  height: 40px;
  padding: var(--ds-space-075, 6px);
  font-size: 14px;
  font-weight: var(--ds-font-weight-bold, 700);
  text-align: left;
  cursor: pointer;
}
.itBVBT9AQ__EL2 .YXvzIIqT8dMr38 {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.itBVBT9AQ__EL2 .YXvzIIqT8dMr38 svg {
  width: 16px;
  height: 16px;
  margin-right: var(--ds-space-050, 4px);
}
.itBVBT9AQ__EL2:hover {
  background: none;
}
.itBVBT9AQ__EL2:focus {
  outline: none;
}
.bYbIf6gGCMkh9h {
  transform: rotate(-90deg);
  transition: transform 0.1s;
}
.bYbIf6gGCMkh9h.BCPGLz7ZXDe7dO {
  transform: rotate(0deg);
}
`, ""]);
// Exports
export var expandSection = `XuXFkJW8xO_NoW`;
export var heading = `kaUDltleo64VCW`;
export var actions = `isZVqKA3jLl0YR`;
export var active = `rsx2KAuQpRoK_L`;
export var button = `itBVBT9AQ__EL2`;
export var title = `YXvzIIqT8dMr38`;
export var icon = `bYbIf6gGCMkh9h`;
export var expanded = `BCPGLz7ZXDe7dO`;
export default ___CSS_LOADER_EXPORT___;
